import Script from "next/script";
import { EnvironmentType } from "@/config";

export default function MazeSnippet() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT === EnvironmentType.BLUE ? (
    <Script id="snippet-maze" strategy="lazyOnload">
      {`
        (function (m, a, z, e) {
          var s, t;
          try {
            t = m.sessionStorage.getItem("maze-us");
          } catch (err) {}

          if (!t) {
            t = new Date().getTime();
            try {
              m.sessionStorage.setItem("maze-us", t);
            } catch (err) {}
          }

          s = a.createElement("script");
          s.src = z + "?apiKey=" + e;
          s.async = true;
          a.getElementsByTagName("head")[0].appendChild(s);
          m.mazeUniversalSnippetApiKey = e;
        })(window, document, "https://snippet.maze.co/maze-universal-loader.js", "e77e4ab9-9411-4e02-b1b3-60fa175c5e95");
      `}
    </Script>
  ) : null;
}
